import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { IFacturaSerie } from "../entidad/Factura";

// type SerieType = "factura"
export function _SvFacturaObtenerSeries(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerSeries"
    const params = {
        "IdEscuela": idEscuela,
        "Tipo": "factura",
    }
    return DataDRequest._Request5<IFacturaSerie[]>(url, "GET", params)
}